import { useState, useEffect } from 'react'
import { mqSizes } from '@helpers/variables'

const calculateBreakpoints = width => {
    const breakpoints = { ...mqSizes }
    Object.entries(mqSizes).forEach(([key, val]) => {
        breakpoints[key] = val >= width
    })
    return breakpoints
}

const getWindowSize = () => {
    if (typeof window === 'undefined') {
        return { width: undefined, height: undefined }
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    }
}

const useResponsive = () => {
    const [windowSize, setWindowSize] = useState(getWindowSize)
    const [breakpoints, setBreakpoints] = useState(
        calculateBreakpoints(windowSize.width)
    )
    useEffect(() => {
        const handleResize = () => {
            const windowSize = getWindowSize()
            setWindowSize(windowSize)
            setBreakpoints(calculateBreakpoints(windowSize.width))
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return {
        windowSize,
        breakpoints,
    }
}

export { useResponsive }
